import { authHttpClient, jwtToken } from '@webmotors/consumer-shared-auth';
import type { TSellerPhoneServiceParams, TFetchUserPhoneResponse } from './seller-phone.types';

/** Serviço para buscar o telefone do vendedor via API PF. */
export const sellerPhoneService = {
  async fetchUserPhone(params: TSellerPhoneServiceParams): Promise<string | undefined> {
    const response = await authHttpClient.get<TFetchUserPhoneResponse>(
      `${import.meta.env.VITE_API_PF_URL}v1/anunciante/get-seller-phone`,
      {
        params: {
          jwt: jwtToken(),
          sellerId: params.userIdTo,
          buyerId: params.userIdFrom,
          chatType: params.chatType,
        },
      },
    );
    return response.data?.Retorno?.Result;
  },
};
